import ReactGa from 'react-ga';

const event = {
  send: (data) => {
    ReactGa.event(data);
  },
  pageView: () => {
    ReactGa.pageview(window.location.pathname + window.location.search);
  } 
}

export default event;